import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import FormSubmit from '@rad/components/dynamic-form/submit';
import LayoutRoot from './root';
export const Layout = (props) => {
    // const notifications = useNotifications()
    return _jsx(_Fragment, { children: _jsxs(LayoutRoot, { toolbarRight: props.toolbarRight, children: [_jsx("h5", { children: props.title }), _jsxs("form", { onSubmit: props.onSubmit, children: [_jsx(FormSubmit, { value: props.form, onChange: props.onChange }), _jsx("div", { className: "text-end mt-2", children: _jsx("button", { type: "submit", className: "btn btn-sm btn-primary", children: "Submit" }) })] })] }) });
};
export default Layout;
